/**
 * `common` namespace — Korean translations.
 *
 * Mirrors `en/common.ts` exactly: the `Record<CommonKey, string>` annotation makes
 * a missing or misspelled key a compile error, so this file can never drift out of
 * sync with the canonical English source. Concise 명사형/합니다체 for UI chrome.
 */
import type { CommonKey } from "../en/common";

export const common: Record<CommonKey, string> = {
  // ── transient status ──
  loading: "불러오는 중",
  saving: "저장 중",
  saved: "저장됨",
  syncing: "동기화 중",

  // ── generic actions ──
  save: "저장",
  cancel: "취소",
  retry: "다시 시도",
  tryAgain: "다시 시도해 주세요.",
  confirm: "확인",
  close: "닫기",
  remove: "제거",
  delete: "삭제",
  edit: "편집",
  refresh: "새로고침",
  sync: "동기화",
  back: "뒤로",
  done: "완료",

  // ── generic status / feedback ──
  errorGeneric: "문제가 발생했습니다.",
  saveFailed: "저장하지 못했습니다. 다시 시도해 주세요.",
  loadFailed: "불러오지 못했습니다. 다시 시도해 주세요.",
  emptyGeneric: "아직 항목이 없습니다.",
  requiredField: "필수 항목입니다.",

  // ── shared interpolated copy ──
  selectedCount: "{count}개 선택",
};
